import { render, staticRenderFns } from "./AdminEditShopOrder.vue?vue&type=template&id=0868e122&scoped=true&"
import script from "./AdminEditShopOrder.vue?vue&type=script&lang=js&"
export * from "./AdminEditShopOrder.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditShopOrder.vue?vue&type=style&index=0&id=0868e122&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0868e122",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0868e122')) {
      api.createRecord('0868e122', component.options)
    } else {
      api.reload('0868e122', component.options)
    }
    module.hot.accept("./AdminEditShopOrder.vue?vue&type=template&id=0868e122&scoped=true&", function () {
      api.rerender('0868e122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminEditShopOrder.vue"
export default component.exports